import React from 'react';
import HeroSlider from './HeroSlider';
import SectionBlock from './SectionBlock';
import EventCarousel from './events/EventCarousel';
import DidYouKnow from './DidYouKnow';
import {sectionBlocks} from '../data/homeData';
import {motion} from 'framer-motion';

export default function Home({onNavigate}) {
  return (
    <div className="text-white">
      <HeroSlider onExplore={onNavigate} />
      <DidYouKnow />
      <EventCarousel onOpen={(event)=> onNavigate('eventos', event)} />

      <section className="max-w-7xl mx-auto px-6 py-24 md:py-32">
        <div className="flex flex-col items-center mb-20 text-center">
          <motion.span
            initial={{opacity: 0}}
            whileInView={{opacity: 1}}
            className="text-red-500 font-black tracking-[0.4em] uppercase text-[10px] mb-4"
          >
            Moo Duk Kwan México
          </motion.span>

          <h2 className="text-5xl md:text-7xl font-black uppercase tracking-tighter mb-8">
            Disciplinas del Dojang
          </h2>

          <div className="h-1 w-24 bg-gradient-to-r from-transparent via-red-600 to-transparent" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {sectionBlocks.map(section=> (
            <SectionBlock key={section.id} section={section} onClick={onNavigate} />
          ))}
        </div>
      </section>

      <section className="px-6 py-32">
        <div className="max-w-5xl mx-auto glass-card rounded-[3rem] p-12 md:p-24 text-center relative overflow-hidden">
          <div className="absolute top-0 right-0 w-64 h-64 bg-red-600/5 blur-[100px] rounded-full -mr-32 -mt-32" />
          <div className="absolute bottom-0 left-0 w-64 h-64 bg-white/5 blur-[100px] rounded-full -ml-32 -mb-32" />

          <h3 className="text-red-400 text-lg md:text-xl font-black tracking-[0.6em] uppercase mb-12 relative z-10 [text-shadow:_0_2px_8px_rgba(0,0,0,0.85)]">
            Filosofía
          </h3>

          <p className="text-2xl md:text-4xl font-light italic text-white leading-tight mb-12 relative z-10 tracking-tight [text-shadow:_0_2px_8px_rgba(0,0,0,0.85)]">
            "El arte marcial es la filosofía de la seriedad, del orgullo, del honor, de la limpieza,<br className="hidden md:block" />
            del buen manejo de su persona, puesto en práctica en cada entrenamiento y en la vida diaria."
          </p>

          <div className="text-red-300 font-black tracking-[0.3em] text-xs uppercase relative z-10 [text-shadow:_0_2px_8px_rgba(0,0,0,0.85)]">
            Dr. Manuel Mondragón y Kalb · Padre de las artes marciales en México
          </div>
        </div>
      </section>
    </div>
  );
}